function openDialogModal(title, contentUrl, ...callbackFunctions) {
    $("#modal-dialog-content").load(contentUrl, function() {
        $("#modal-dialog-title").html(title);
        $('#modal-dialog').modal();

        for(let callbackFunction of callbackFunctions) {
            if(typeof callbackFunction == "function") {
                callbackFunction();
            }
        }
    });
}

function openDialogModalLoggedIn(title, contentUrl, hideFooter = false, ...callbackFunctions) {
    redirectOnLogout();

    let modalDialog = $("#modal-dialog .modal-dialog");
    let modalDialogFooter = $("#modal-dialog .modal-footer");
    let modalDialogContent = $("#modal-dialog-content");

    modalDialog.removeClass("modal-lg");

    $("#modal-dialog-content").load( contentUrl, function() {
        $("#modal-dialog-title").html(title);
        $('#modal-dialog').modal();

        for(let callbackFunction of callbackFunctions) {
            if(typeof callbackFunction == "function") {
                callbackFunction();
            }
        }
    });

    if(hideFooter) {
        modalDialogFooter.addClass("d-none");
        modalDialogContent.addClass("pb-0");
    } else {
        modalDialogFooter.removeClass("d-none");
        modalDialogContent.removeClass("pb-0");
    }
}

function openAktionModal(title, contentUrl) {
    $("#modal-aktion-content").load(contentUrl, function() {
        $("#modal-aktion-title").html(title);
        $('#modal-aktion').modal();
    });
}